import { render } from "./SaveLeaveType.vue?vue&type=template&id=3acf3120&scoped=true"
import script from "./SaveLeaveType.vue?vue&type=script&lang=js"
export * from "./SaveLeaveType.vue?vue&type=script&lang=js"

import "./leave-type.scss?vue&type=style&index=0&id=3acf3120&lang=scss&scoped=true"

import exportComponent from "/Users/balbeer.yadav/Development/lmthrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3acf3120"]])

export default __exports__